import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleCallback() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const storedState = sessionStorage.getItem('oauth_state');
      const integrationId = sessionStorage.getItem('integration_id');

      if (integrationId) {
        if (!code || !state || !storedState || state !== storedState) {
          console.error('Invalid OAuth callback');
          navigate('/');
          return;
        }

        try {
          const response = await fetch('/api/oauth/callback', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, state, integrationId })
          });

          if (!response.ok) throw new Error('Failed to exchange code');

          await supabase
            .from('integration_status')
            .upsert({
              integration_id: integrationId,
              status: 'completed',
              updated_at: new Date().toISOString()
            });

          sessionStorage.removeItem('oauth_state');
          sessionStorage.removeItem('integration_id');
          sessionStorage.removeItem('code_verifier');

          navigate('/setup/integrations');
        } catch (error) {
          console.error('OAuth callback error:', error);
          navigate('/');
        }
      } else {
        if (!code) {
          console.error('No authorization code received');
          toast.error('Authentication failed');
          navigate('/');
          return;
        }

        try {
          const { data, error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) throw error;
          const session = data.session;

          if (!session) {
            throw new Error('Session not established');
          }

          toast.success('Successfully signed in with Google!');
          navigate('/');
        } catch (error) {
          console.error('Google OAuth callback error:', error);
          toast.error(error instanceof Error ? error.message : 'Failed to complete sign in');
          navigate('/');
        }
      }
    }

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-scale-dark flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-scale-blue border-t-transparent mx-auto mb-4"></div>
        <p className="text-white">Completing integration setup...</p>
      </div>
    </div>
  );
}
